import {useQueryClient} from 'react-query';
import Button from '../../../../components/button';
import MainFooter from '../../../../components/mazraeKit/footers/footerMain';
import SpinnerLoading from '../../../../components/SpinnerLoading';
import useDeleteLoanRequest from '../../../../services/hookService/deleteLoanRequest/useDeleteLoanRequest';
import useGetListLoanRequest from '../../../../services/hookService/getListLoanRequest/useGetListLoanRequest';
import useGetLoanRequest from '../../../../services/hookService/getLoanRequest/useGetLoanRequest';
import {
  LoanRequestStatus,
  showCancelButtonByLoanStatus,
} from '../../../myAccount/my-credits/consts/loanStatus';
import MultiStepComponent from '../MultiStepComponent';
import {receiveCreditSteps} from '../receiveCreditSteps';
import LoanRequestHeader from '../step3-completeDocs/components/LoanRequestHeader';
import RejectLoanRequestDesc from './RejectLoanRequestDesc';

const RejectLoanRequestPage = () => {
  const queryClient = useQueryClient();

  const {data: listLoanRequest, isLoading: isLoadingListLoanRequest} =
    useGetListLoanRequest({is_finished: false});

  const {data: loanRequest, isLoading: isLoadingLoanRequest} =
    useGetLoanRequest({
      loanRequestGuid: listLoanRequest?.guid!,
      enabled: Boolean(listLoanRequest?.guid),
    });
  const {mutate, isLoading: isDeleteLoanLoading} = useDeleteLoanRequest();

  const handleDeleteLoanRequest = () => {
    mutate(listLoanRequest?.guid!, {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: ['get-list-loan-request'],
        });
        window.location.href = '/my-credits/startLoanCredit'; // Navigate AND refresh. this is needed to avoid white screen step when user comes back to step pages
      },
    });
  };

  const isLoading = isLoadingListLoanRequest || isLoadingLoanRequest;

  if (!isLoading && !loanRequest?.rejection_reason)
    return <div>مشکلی پیش آمده لطفا با پشتیبانی تماس بگیرید</div>;

  return (
    <div className="flex flex-col w-full bg-white h-dvh">
      {/* Header */}
      <LoanRequestHeader
        backPath="/my-credits"
        title="دریافت اعتبار"
        loanRequestGuid={listLoanRequest?.guid}
        showCancelButton={showCancelButtonByLoanStatus(
          listLoanRequest?.status as LoanRequestStatus,
        )}
      />
      {/* Content */}
      <div className="flex flex-col w-full h-full gap-3 py-3 px-[1.5rem] overflow-y-auto">
        {isLoading && (
          <div className="grid h-dvh place-content-center">
            <SpinnerLoading />
          </div>
        )}

        {!isLoading && (
          <>
            <MultiStepComponent steps={receiveCreditSteps} currentStep={5} />

            <section className="flex flex-col gap-[1.5rem] mt-3 text-sm">
              <span className="font-medium ">دریافت اعتبار</span>
              <RejectLoanRequestDesc
                rejectDescription={loanRequest?.rejection_reason!}
              />
              <div className="fixed left-0 right-0 z-50 flex flex-col w-full gap-2 bottom-2 ">
                <div className="p-3">
                  <Button
                    type="button"
                    className="w-full"
                    onClick={handleDeleteLoanRequest}
                    isLoading={isDeleteLoanLoading}
                  >
                    متوجه شدم
                  </Button>
                </div>

                <MainFooter isScrolling={false} />
              </div>
            </section>
          </>
        )}
      </div>
    </div>
  );
};

export default RejectLoanRequestPage;
